module.exports = __webpack_public_path__ + "img/54.524200a9.jpg";